import React from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"
import { Tab as TabMaterial, Badge } from "@mui/material"

export interface TabProps {
  label: string
  badge?: number
  value?: string
  disabled?: boolean
  maxWidth?: string
  minWidth?: string
  color?: string
}

export const Tab = (props: TabProps) => {
  const { label, badge, disabled, value, maxWidth, minWidth, color, ...restProps } = props
  const getBadge = () => {
    return badge ? (
      <CustomBadge badgeContent={badge} color="primary">
        {" "}
        {label}{" "}
      </CustomBadge>
    ) : (
      label
    )
  }

  return (
    <CustomTab
      disabled={disabled}
      label={getBadge()}
      value={value}
      $maxWidth={maxWidth}
      $minWidth={minWidth}
      $color={color}
      {...restProps}
    />
  )
}

const CustomTab = styled(TabMaterial)<{ $minWidth?: string; $maxWidth?: string; $color?: string }>`
  ${(p) =>
    p.$color &&
    css`
      color: ${p.$color};
    `}
  &.MuiTab-root {
    ${(p) =>
      p.$minWidth &&
      css`
        min-width: ${p.$minWidth};
      `}
    ${(p) =>
      p.$maxWidth &&
      css`
        max-width: ${p.$maxWidth};
      `}
  }
`

const CustomBadge = styled(Badge)`
  align-items: center;

  & .MuiBadge-badge {
    position: relative;
    transform: none;
    margin-left: ${theme.spacing.m};
  }
`
